// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__3JQRJ","modalFooterButton":"ModalNotes_modalFooterButton__3UZwZ"};